"use client";
import React, { useState } from "react";
import PaymentMethodSelector from "./../components/donate/PaymentMethodSelector";
import QRCodePayment from "./../components/donate/QRCodePayment";
// import BuyMeACoffeePayment from "./../components/donate/BuyMeACoffeePayment";
// import StripePayment from "./../components/donate/StripePayment";
import TopBarSignedIn from "./../components/common/TopBarSignedIn";

const DonatePage = () => {
  const [paymentMethod, setPaymentMethod] = useState("qrcode");

  const renderPaymentMethod = () => {
    switch (paymentMethod) {
      case "qrcode":
        return <QRCodePayment />;
      case "buymeacoffee":
      // return <BuyMeACoffeePayment />;
      case "stripe":
      // return <StripePayment />;
      default:
        return <QRCodePayment />;
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <TopBarSignedIn />

      <main className="flex-1 w-full max-w-4xl mx-auto px-6 py-8">
        <section className="text-center mb-10">
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            Hỗ trợ đội ngũ phát triển
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Khoản quyên góp của bạn giúp chúng tôi duy trì và cải thiện nền tảng
            của mình, tạo ra những trải nghiệm tốt hơn cho cộng đồng năng lượng
            trên toàn thế giới. Chọn phương thức thanh toán ưa thích của bạn bên
            dưới.
          </p>
        </section>

        <PaymentMethodSelector
          selectedMethod={paymentMethod}
          onSelectMethod={setPaymentMethod}
        />

        <div className="mt-8 bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
          {renderPaymentMethod()}
        </div>

        <section className="mt-12 bg-gray-50 rounded-xl p-6 border border-gray-200">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Tại sao cần quyên góp?
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white p-5 rounded-lg shadow-sm">
              <div className="text-rose-700 mb-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-800 mb-2">
                Cơ sở hạ tầng hỗ trợ
              </h3>
              <p className="text-gray-600">
                Giúp chúng tôi duy trì máy chủ, cơ sở dữ liệu và cơ sở hạ tầng
                kỹ thuật khác để cộng đồng của chúng tôi hoạt động trơn tru.
              </p>
            </div>

            <div className="bg-white p-5 rounded-lg shadow-sm">
              <div className="text-rose-700 mb-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-800 mb-2">
                Kích hoạt sự đổi mới
              </h3>
              <p className="text-gray-600">
                Các khoản quyên góp của bạn sẽ tài trợ cho các tính năng và cải
                tiến mới giúp cộng đồng năng lượng hợp tác hiệu quả hơn.
              </p>
            </div>

            <div className="bg-white p-5 rounded-lg shadow-sm">
              <div className="text-rose-700 mb-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-800 mb-2">
                Phát triển cộng đồng vững mạnh hơn
              </h3>
              <p className="text-gray-600">
                Các khoản quyên góp giúp chúng tôi tiếp cận được nhiều người hơn
                và giúp cho việc tìm hiểu, nghiên cứu phương pháp đồng hành cùng
                con một cách dễ dàng hơn
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default DonatePage;
